module.exports = __webpack_public_path__ + "static/media/spinner.0de2083b.png";